import { render, staticRenderFns } from "./producao.vue?vue&type=template&id=a8ed15de&scoped=true"
import script from "./producao.vue?vue&type=script&lang=ts"
export * from "./producao.vue?vue&type=script&lang=ts"
import style0 from "./producao.vue?vue&type=style&index=0&id=a8ed15de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ed15de",
  null
  
)

export default component.exports